// Project Metadata
export const PROJECT = {
  name: 'Ponte Rio Tocantins',
  contract: 'CT5500097701',
  client: 'Vale S.A.',
  contractor: 'Consórcio Novo Tocantins (Camargo Corrêa / CCCC)',
  consultant: 'Manta Engenharia',
  location: 'Marabá, PA - Brasil',
  description: 'Construção de ponte rodoferroviária sobre o Rio Tocantins',
} as const;

// Contract Values
export const CONTRACT_VALUES = {
  original: 1_680_000_000, // R$ 1,68 bilhões
  amendments: [
    { number: 1, value: 45_000_000, description: 'Aditivo de escopo' },
    { number: 2, value: 85_000_000, description: 'Reequilíbrio econômico-financeiro' },
  ],
  rebalanceClaim: 130_000_000, // R$ 130 milhões em discussão
} as const;

// Key Milestones
export const MILESTONES = {
  contractStart: '2021-03-15',
  originalEnd: '2024-12-31',
  currentEnd: '2026-06-30',
  bl01Start: '2021-06-01',
  bl01End: '2025-12-31',
} as const;

// Performance Indicators Thresholds
export const KPI_THRESHOLDS = {
  cpi: { good: 1.0, warning: 0.9, critical: 0.8 },
  spi: { good: 1.0, warning: 0.9, critical: 0.8 },
  rqd: { excellent: 90, good: 75, fair: 50, poor: 25 },
} as const;

// Navigation Links
export const NAV_LINKS = [
  { path: '/', label: 'Portal', icon: 'Home' },
  { path: '/reequilibrio', label: 'Reequilíbrio', icon: 'Scale' },
  { path: '/cronograma', label: 'Cronograma', icon: 'Calendar' },
  { path: '/disrupcao', label: 'Disrupção', icon: 'AlertTriangle' },
  { path: '/geologia', label: 'Geologia', icon: 'Mountain' },
  { path: '/produtividade', label: 'Produtividade', icon: 'TrendingUp' },
  { path: '/atas', label: 'Atas', icon: 'FileText' },
  { path: '/relatorios/v5', label: 'Relatórios', icon: 'BookOpen' },
  { path: '/financeiro', label: 'Financeiro', icon: 'DollarSign' },
] as const;

// SharePoint Integration URLs (placeholders)
export const SHAREPOINT = {
  baseUrl: 'https://vale.sharepoint.com/sites/PonteRioTocantins',
  folders: {
    atas: '/Documentos/Atas',
    cartas: '/Documentos/Cartas',
    rmp: '/Documentos/RMP',
    medicoes: '/Documentos/Medicoes',
    contrato: '/Documentos/Contrato',
  },
} as const;
